/**
 * Merge on the number at app open (f/simple-merge, migration 039).
 *
 * The server merges every Simple profile carrying a confirmed number into the
 * account at conversion and at phone-code login. A Full person already signed
 * in never logs in again, so "Open the Royale app to log in" (the Join answer
 * for a number that already has an account) would merge nothing — the app
 * asks once per Full boot instead. The server checks ownership itself (the
 * session's verified phone against its own Full profile); anything else is a
 * no-op. Connections only — the account's profile is never touched.
 */

import { supabase } from '../supabase';
import { isFullTier } from '../../utils/userTier';
import { getProfileUserId } from '../../utils/identityUtils';
import { topUpMissingConnections } from '../storage/dataRecovery';

/**
 * Run the merge for this Full account; when it moved anything, bring the new
 * rooms onto the phone.
 * @returns {Promise<number>} connections restored onto the phone (0 when nothing merged)
 */
export const mergeMyNumberAtOpen = async () => {
  if (!isFullTier()) return 0;
  const { data, error } = await supabase.rpc('merge_my_number');
  if (error) {
    console.warn('[NUMBER_MERGE] merge_my_number failed:', error.message);
    return 0;
  }
  const merged = data?.merged_profiles || 0;
  if (merged === 0) return 0;
  console.log('[NUMBER_MERGE] Merged', merged, 'Simple profile(s) into this account');
  return topUpMissingConnections(getProfileUserId());
};
